import { type CalendarEvent, calendarLessonArrangement } from "@classroom/domain";
import { i18n, useTranslation } from "./i18n";

export function calendarArrangementLabel(event: CalendarEvent) {
  const arrangement = calendarLessonArrangement(event);
  return arrangement ? i18n.t(`schoolCalendar:arrangements.${arrangement}`) : undefined;
}

export default function CalendarArrangement({ event }: { event: CalendarEvent }) {
  const { t } = useTranslation("schoolCalendar");
  const arrangement = calendarLessonArrangement(event);
  return arrangement ? (
    <span className={`calendar-arrangement ${arrangement}`}>{t(`arrangements.${arrangement}`)}</span>
  ) : null;
}
